import * as React from "react";
import * as S from "@styled";
import _ from "lodash";

import { AgentGroup } from "../../../shared/model/AgentGroup";

import AgentGroupSelectMenu from "../../../shared/components/AgentGroupSelectMenu";
import { ChangeEvent } from "../../../shared/model/Event";
import { DeployDialogTable } from "./DeployDialog";

export const DeployDialogBody: React.FC<DeployDialogBodyProps> = (props) => {
    const gridTemplateColumns: string = props.table.columns
        .map((column) => `[${column.id}] ${column.width}`)
        .reduce((a, b) => a + " " + b);

    return (
        <S.FormGroup style={{ marginBottom: "40px" }}>
            {!props.isSwitchVersion && (
                <S.FormGroup>
                    <S.Label htmlFor="deployEnvironmentSelector" className="target-environment-label-selector deploy-label">{FRENDS.Localizations.Process_DeployToAgentGroup}&nbsp;</S.Label>
                    <S.FlexContainer>
                        <AgentGroupSelectMenu
                            currentAgentGroupName={props.targetAgentGroupName}
                            agentGroups={props.agentGroupsForDeployment}
                            onChangeAgentGroup={props.onSetTargetAgentGroup}
                        />
                    </S.FlexContainer>
                    {props.warnApiPassthroughConfiguration != null ?
                            <S.WarningContainer style={{ marginTop: "20px" }}>
                                <div className="alert-warning">
                                    <div className="alert-label">
                                        {FRENDS.Localizations.Warning}
                                    </div>
                                    <div className="alert-content">
                                        {props.warnApiPassthroughConfiguration} Passthrough configuration will be ignored.
                                    </div>
                                </div>
                            </S.WarningContainer>
                        : null
                    }
                    <hr />
                </S.FormGroup>
            )}
            <div key={gridTemplateColumns}
                style={{
                    display: "grid",
                    gridTemplateColumns: gridTemplateColumns,
                    columnGap: "24px",
                    rowGap: "15px",
                    alignItems: "center"
                }}
            >
                {props.table.columns.map((column) => <div key={column.id} style={{ fontWeight: "bold", gridColumn: column.id }}>{column.name}</div>)}
                {props.table.cells.map((row) => row.map((cell) => <div key={cell.columnId} style={{ gridColumn: cell.columnId }} className={cell.className}><>{cell.value}</></div>))}
            </div>

            {!props.isSwitchVersion &&
                <S.FormGroup>
                    <hr />
                    <S.TextArea
                        value={props.deploymentDescription}
                        onChange={props.onChangeDeploymentDescription}
                        placeholder={FRENDS.Localizations.DeploymentDescriptionPlaceholder}
                        maxLength={1000}
                    />
                </S.FormGroup>
            }
        </S.FormGroup>
    );
};

interface DeployDialogBodyProps {
    isSwitchVersion: boolean;
    targetAgentGroupName: string;
    agentGroupsForDeployment: AgentGroup[];
    table: DeployDialogTable;
    deploymentDescription: string;
    warnApiPassthroughConfiguration: string | null;
    onSetTargetAgentGroup: (environment: string, agentGroupName: string) => void;
    onChangeDeploymentDescription: (event: ChangeEvent<HTMLTextAreaElement>) => void;
}
